module.exports = __webpack_public_path__ + "img/cellphone-key.b2f3eb4e.svg";